const UH_EVENTS = {
  PERSONAL_INFO: 'uh-pn-click-emit_personal_information',
  SECURITY: 'uh-pn-click-emit_security',
  SETTINGS: 'uh-pn-click-emit_settings',
};

export default UH_EVENTS;
